import React, { useEffect, useRef, useState } from "react";
import {
  StyleSheet,
  View,
  Pressable,
  Linking,
  BackHandler,
  Alert,
} from "react-native";
import Deactivated from "@assets/svg/Deactivated";
import Text from "@components/AppText";
import colors from "@constants/color";
import { normalize } from "@utils/metrics_1";
import t from "@constants/localization";
import { useSelector } from "react-redux";
import { useFocusEffect } from "@react-navigation/native";
import analytics from "@services/analytics";
import { DEACTIVATION_SCREEN_VIEWED } from "@constants/analyticsEvents";
import OpenAccount from "./OpenAccount";

const PATH = "screens/SelfDeactivation/index";

const SelfDeactivation = (props) => {
  const [visible, setVisible] = useState(false);
  const [showIndex, setIndex] = useState(false);
  const { canContact } = useSelector(({ auth }) => auth);
  const backHandler = useRef();
  const backClickCount = useRef(0);
  const handleAppShare = async () => {
    try {
      Linking.openURL("https://s.ctml.in/mxGetyaYkab");
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    setTimeout(() => {
      setIndex(true);
    }, 300);
  }, []);

  useFocusEffect(
    React.useCallback(() => {
      backHandler.current = BackHandler.addEventListener(
        "hardwareBackPress",
        goingBackHandler,
      );
      analytics.trackEvent(DEACTIVATION_SCREEN_VIEWED);
      return () => backHandler.current.remove();
    }, []),
  );

  const goingBackHandler = () => {
    if (backClickCount.current === 1) {
      console.log(backClickCount.current);
      Alert.alert(
        t(`${PATH}/exit`),
        t(`${PATH}/cnfmExit`),
        [
          {
            onPress: () => BackHandler.exitApp(),
            text: t(`${PATH}/yes`),
          },
          {
            style: "cancel",
            text: t(`${PATH}/no`),
            onPress: () => {
              backClickCount.current = 0;
            },
          },
        ],
        { cancelable: false },
      );
      return true;
    }
    backClickCount.current++;
    return true;
  };

  return (
    <>
      {!canContact && showIndex ? (
        <View style={styles.container}>
          <Deactivated />
          <View style={{ justifyContent: "center", alignItems: "center" }}>
            <Text style={styles.text1}>{t(`${PATH}/yourAccountDeleted`)}</Text>
            <Text style={styles.text2}>{t(`${PATH}/stillYouCanPurchase`)}</Text>
          </View>
          <View style={styles.buttonView}>
            <Pressable
              style={styles.button}
              onPress={() => {
                setVisible(true);
              }}
            >
              <Text style={styles.buttonText}>{t(`${PATH}/contact`)}</Text>
            </Pressable>
          </View>

          <View style={styles.buttonViewApp}>
            <Pressable style={styles.buttonApp} onPress={handleAppShare}>
              <Text style={styles.buttonTextApp}>
                {t(`${PATH}/downloadCustomerApp`)}
              </Text>
            </Pressable>
          </View>
          <OpenAccount visible={visible} setVisible={setVisible} />
        </View>
      ) : showIndex ? (
        <View style={styles.container}>
          <Deactivated />
          <View style={{ justifyContent: "center", alignItems: "center" }}>
            <Text style={styles.text1}>{t(`${PATH}/willReactivateSoon`)}</Text>
            <Text style={styles.text2}>{t(`${PATH}/youCanPurchase`)}</Text>
          </View>
          <View style={[styles.buttonView, { marginTop: normalize(44) }]}>
            <Pressable style={styles.button} onPress={handleAppShare}>
              <Text style={styles.buttonText}>
                {t(`${PATH}/downloadCustomerApp`)}
              </Text>
            </Pressable>
          </View>
        </View>
      ) : null}
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "white",
    justifyContent: "center",
    alignItems: "center",
  },
  text1: {
    fontSize: normalize(16),
    lineHeight: normalize(24),
    paddingHorizontal: normalize(42),
    textAlign: "center",
    fontFamily: "NotoSansDevanagari-Bold",
  },
  text2: {
    marginTop: normalize(10),
    fontSize: normalize(14),
    lineHeight: normalize(20),
    paddingHorizontal: normalize(16),
    textAlign: "center",
    fontFamily: "NotoSansDevanagari-Regular",
  },
  buttonView: {
    width: "100%",
    paddingHorizontal: normalize(16),
    backgroundColor: "white",
  },
  button: {
    marginTop: normalize(16),
    backgroundColor: "#E40046",
    borderRadius: 6,
    paddingVertical: normalize(12),
  },
  buttonText: {
    fontSize: normalize(18),
    lineHeight: normalize(28),
    color: colors.white,
    textAlign: "center",
    fontFamily: "NotoSansDevanagari-SemiBold",
  },

  buttonViewApp: {
    width: "65%",
    backgroundColor: "white",
  },
  buttonApp: {
    borderWidth: 1,
    borderColor: "rgba(0, 0, 0, 0.2)",
    marginTop: normalize(16),
    backgroundColor: "white",
    borderRadius: 6,
    paddingVertical: normalize(6),
  },
  buttonTextApp: {
    fontSize: normalize(16),
    lineHeight: normalize(24),
    color: "black",
    textAlign: "center",
    fontFamily: "NotoSansDevanagari-SemiBold",
  },
});

export default SelfDeactivation;
